<!--
<mat-chip-list *ngIf="cc.usedBy | async as usedBy">
  <mat-chip [ngStyle]="{'background': getColor(item)}" [disabled]="item.disabled" selected *ngFor="let item of filteredList(usedBy)">

  </mat-chip>
</mat-chip-list> -->

@if (cc.usedBy | async; as usedBy) {
  <ul class="md-chips">
    @for (item of filteredList(usedBy); track item) {
      <li class="md-chip" [ngStyle]="{ background: getColor(item) }">
        <span class="md-chip-icon">
          <img class="icon" [src]="getIcon(item)" [alt]="item.useType !== 'Next Step' ? item.useType : ''" />
        </span>
        <span class="md-chip-label">{{ item.name }}</span>
      </li>
    }
  </ul>
}
